export default __webpack_public_path__ + "static/media/mongoose.2b952903.png";